/**
 *
 * Asynchronously loads the component for TransferCertificate
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const TransferCertificate = lazyLoad(
    () => import('./index'),
    module => module.TransferCertificate,
);
